import {
  SET_CLASS_HIERARCHY,
  SET_CLASS_HIERARCHY_OPEN,
  SET_CLASS_HIERARCHY_TICK,
  SET_CLASS_HIERARCHY_SELECTIONS,
  SET_COURSE_HIERARCHY_LOADING,
  SET_RAW_HIERARCHY
} from '../mutation-types'
import {GET_CLASS_HIERARCHY,
  GET_SEARCH_HIERARCHY_RESULTS} from '../action-types'
import server from '../server'

const state = () => ({
  state: false,
  tree: null,
  mapping: new Map(),
  changedTree: false,
  rawTreeData: null,
  parentId: 0
})

const TreeMapper = class {
  constructor () {
    this.mapping = new Map()
  }

  mapCourse (serverCourse, parentId, searchText) {
    let visibility = false
    if (searchText === undefined) {
      visibility = true
    } else if (serverCourse.courseDescription.toUpperCase().indexOf(searchText.toUpperCase()) >= 0 || serverCourse.courseDescription.toUpperCase().indexOf(searchText.toUpperCase()) >= 0) {
      visibility = true
    } else {
      visibility = false
    }
    const node = {
      id: serverCourse.courseIdentifier,
      databaseId: serverCourse.id,
      name: serverCourse.courseDescription,
      ticked: false,
      indeterminate: false,
      isCourse: true,
      isVisible: visibility,
      parentId
    }
    this.mapping.set(node.id, node)
    return node
  }

  remapServerNode (serverNode, searchText, parentId) {
    let childCourses = serverNode.courses.map(course => this.mapCourse(course, serverNode.id, searchText))
      .sort((a, b) => a.name.localeCompare(b.name))
    let hierarchy = serverNode.hierarchyChildren.map(child => this.remapServerNode(child, searchText, serverNode.id))
      .sort((a, b) => a.name.localeCompare(b.name))
    let node = {
      id: serverNode.id,
      name: serverNode.description,
      ticked: false,
      indeterminate: false,
      children: this.organiseCourses(childCourses, hierarchy),
      expanded: false,
      isCourse: false,
      isVisible: true,
      parentId
    }
    this.mapping.set(node.id, node)
    return node
  }

  organiseCourses (hierarchy, childCourses) {
    let orig = childCourses.concat(hierarchy)
    let ob = []
    if (orig.length > 0) {
      Object.keys(orig).forEach((child) => {
        if (orig[child].children) {
          // if hierarchy children exist, push to new object
          if (orig[child].children.length > 0) {
            ob.push(orig[child])
          }
        }
        // if course from course table && not default course, push to new object
        if (orig[child].isCourse && orig[child].databaseId > 0) {
          ob.push(orig[child])
        }
      })
    }
    return ob
  }

  determineTick (node) {
    if (node.children) {
      let count = {ticked: 0, crossed: 0, childCount: node.children.length}
      node.children.forEach(child => {
        this.determineTick(child)
        this.updateCount(count, child)
      })
      this.updateTick(count, node)
    }
  }

  updateCount (counts, child) {
    if (child.ticked) {
      counts.ticked++
    }
    if (child.ticked === false) {
      counts.crossed++
    }
  }

  applyTickDown (id, ticked) {
    let node = this.mapping.get(id)
    node.ticked = ticked
    if (node.children) {
      node.children.forEach(child => this.applyTickDown(child.id, ticked))
    }
  }

  updateTick (count, node) {
    if (count.ticked === count.childCount) {
      node.ticked = true
    } else if (count.crossed === count.childCount) {
      node.ticked = false
    } else {
      node.ticked = undefined
    }
  }

  applyTickUp (id) {
    let node = this.mapping.get(id)
    if (node.parentId) {
      let parent = this.mapping.get(node.parentId)
      let count = {ticked: 0, crossed: 0, childCount: parent.children.length}
      parent.children.forEach(child => {
        this.updateCount(count, child)
      })
      this.updateTick(count, parent)
      this.applyTickUp(parent.id)
    }
  }

  applyTick (id, ticked) {
    this.applyTickDown(id, ticked)
    this.applyTickUp(id)
  }

  remapServerNodes (serverTree, searchText) {
    let tree = this.remapServerNode(serverTree, searchText)
    return {mapping: this.mapping, tree}
  }
}

let mapper = new TreeMapper()

const mutations = {
  [SET_RAW_HIERARCHY] (state, rawTreeDate) {
    state.rawTreeData = rawTreeDate
  },
  [SET_CLASS_HIERARCHY] (state, treeData) {
    state.tree = treeData.tree
    state.parentId = treeData.tree.id
    state.mapping = treeData.mapping
    state.changedTree = false
  },
  [SET_CLASS_HIERARCHY_OPEN] (state, data) {
    state.mapping.get(data.id).expanded = data.expanded
  },
  [SET_CLASS_HIERARCHY_TICK] (state, data) {
    mapper.applyTick(data.id, data.ticked)
    state.changedTree = true
  },
  [SET_CLASS_HIERARCHY_SELECTIONS] (state, classes) {
    // Close all hierarchy. Clear the tick
    state.mapping.forEach(node => {
      node.indeterminate = false
      node.ticked = false
      if (!node.isCourse) {
        node.expanded = false
      }
    })

    state.changedTree = false
    // Tick the classes current applied to the alert
    if (classes) {
      classes.forEach(aClass => {
        mapper.applyTick(aClass, true)
      })
    }

    state.mapping.get(state.tree.id).expanded = true // Open top node
  }
}

const actions = {
  [GET_CLASS_HIERARCHY] ({commit}) {
    commit(SET_COURSE_HIERARCHY_LOADING, true)
    const actionData = { action: GET_CLASS_HIERARCHY }
    server.getReplayable('/core/hierarchy', actionData).then(result => {
      commit(SET_RAW_HIERARCHY, result.data)
      let data = mapper.remapServerNodes(result.data, undefined)
      commit(SET_CLASS_HIERARCHY, data)
      commit(SET_COURSE_HIERARCHY_LOADING, false)
    })
  },

  [GET_SEARCH_HIERARCHY_RESULTS] ({rootState, state, commit}, {searchText}) {
    let data = mapper.remapServerNodes(state.rawTreeData, searchText)
    commit(SET_CLASS_HIERARCHY, data)
  }
}

/* const getters = {
  [GET_HIERARCHY_CLASS_IDS] (state) {
    return Array.from(state.mapping.values()).filter(node => node.ticked && node.isCourse).map(node => node.databaseId)
  }
} */

export default {
  state: state(),
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/hierarchyModule.js